var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.216 2.723a.606.606 0 0 0-.857 0L1.51 7.57a.606.606 0 0 0 0 .857l4.849 4.849a.606.606 0 0 0 .857-.857L3.402 8.606H14.06a.606.606 0 0 0 0-1.212H3.402L7.216 3.58a.606.606 0 0 0 0-.857Z",
    fill: "#fff"
  })));
};

export default SvgArrowLeft;